// @flow

import type {ApplicationState} from '../../types'
import type {SessionState} from '../types'

export function isReady(appState: ApplicationState): ApplicationState {
  return appState
}

function _isReady(state: SessionState): SessionState {
  return state
}

isReady.internal = _isReady
